export default __webpack_public_path__ + "assets/models/c0e0251e47ab5fb6d0378557ea7a0e24.glb";